import { getRouterSelectors, RouterReducerState } from "@ngrx/router-store";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { LoonAction } from "./shared/interfaces/loon-action";

export const selectRouter = createFeatureSelector<RouterReducerState>("router");

export const {
	selectCurrentRoute, // select the current route
	selectFragment, // select the current route fragment
	selectQueryParams, // select the current route query params
	selectQueryParam, // factory function to select a query param
	selectRouteParams, // select the current route params
	selectRouteParam, // factory function to select a route param
	selectRouteData, // select the current route data
	selectUrl, // select the current url
} = getRouterSelectors(selectRouter);

export const selectRosterAction = createSelector(
	selectRouteParam("action"),
	selectRouteData,
	(action, data) => (action as LoonAction) || (data?.action as LoonAction)
);

export const selectRouteResourceName = createSelector(
	selectRouteParam("memberReference"),
	selectRouteParam("officeNumber"),
	selectRouteParam("firmReference"),
	(member, office, firm) =>
		!!member ? "Member" : !!office ? "Office" : !!firm ? "Firm" : undefined
);

export const selectRouteResourceReference = createSelector(
	selectRouteParam("memberReference"),
	selectRouteParam("officeNumber"),
	selectRouteParam("firmReference"),
	(member, office, firm) => member ?? office ?? firm
);

export const selectRouteNestedParams = createSelector(selectRouter, (router) => {
	let currentRoute = router?.state?.root;
	let params: { [key: string]: any } = {};
	while (currentRoute?.firstChild) {
		currentRoute = currentRoute.firstChild;
		params = {
			...params,
			...currentRoute.params,
		};
	}
	return params;
});

export const selectRouteNestedParam = (property: string) =>
	createSelector(selectRouteNestedParams, (params) => params && params[property]);

export const selectRouteNestedData = createSelector(selectRouter, (router) => {
	let currentRoute = router?.state?.root;
	let data: { [key: string]: any } = {};
	while (currentRoute?.firstChild) {
		currentRoute = currentRoute.firstChild;
		data = {
			...data,
			...currentRoute.data,
		};
	}
	return data;
});

export const selectRouteNestedDataByProperty = (property: string) =>
	createSelector(selectRouteNestedData, (data) => data && data[property]);
